package pt.at.oss.kotlin.core.i18n

/**
 * Locales supported by Kotlin-defined i18n enums.
 */
enum class PageLocale(val localeId: String) {
    PT("pt-PT"),
    EN("en-US")
}
